import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import api from '../Axios/axios';
import { FaArrowRight } from 'react-icons/fa';
import './HasTowerCraneCompanyList.scss';

export default function HasTowerCraneCompanyList() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/Company')
      .then(res => {
        const list = res.data.data
          .filter(c => c.hasTowerCrane)
          .map(c => ({
            id: c.id,
            name: c.name,
            email: c.email,
            phone: c.phoneNumber1 || '-',
          }));
        setCompanies(list);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="has-tower-crane-company-list">
        <Navbar />
        <p>Yükleniyor…</p>
      </div>
    );
  }

  return (
    <div className="has-tower-crane-company-list">
      <Navbar />
      <h1>Kule Vinci Olan Firmalar</h1>
      <div className="table-container">
        <table className="companies-table">
          <thead>
            <tr>
              <th>Firma Adı</th>
              <th>E-Posta</th>
              <th>Telefon</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {companies.map(c => (
              <tr key={c.id}>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td>{c.phone}</td>
                <td className="actions">
                  <button
                    className="go-btn"
                    onClick={() => navigate(`/accountpage/${c.id}`)}
                    aria-label="Go to account page"
                  >
                    <FaArrowRight />
                  </button>
                </td>
              </tr>
            ))}
            {companies.length === 0 && (
              <tr>
                <td colSpan="5">Kayıtlı firma bulunamadı.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
